/**
 * Technology & Digital Reach Translations Module (Japanese)
 * 
 * Contains: Website Analytics, Social Media, LEADER Magazine, Technology Trends
 * 
 * @module technology
 * @language ja
 */

export const technology = {
  technologyFuture: {
    pageTitle: "テクノロジーとデジタルリーチ",
    pageSubtitle: "JCI.cc • ソーシャルメディア • LEADERマガジン | 26万人以上のフォロワー、70か国以上"
  },
  technologyRole: {
    title: "テクノロジーの役割",
    subtitle: "JCIがテクノロジーを活用して若いリーダーをつなぎ、エンパワーする方法",
    new: "新着"
  },
  programs: {
    jciWebsite: "JCI.ccウェブサイト",
    website: "ウェブサイト",
    socialMedia: "ソーシャルメディア",
    social: "ソーシャル",
    leaderMagazine: "LEADERマガジン",
    magazine: "マガジン",
    activeUsers: "アクティブユーザー",
    pageViews: "ページビュー",
    avgSession: "平均セッション",
    bounceRate: "直帰率",
    returnVisitors: "リピート訪問者",
    mobileAccess: "モバイルアクセス",
    mobileFirstApproach: "モバイルファーストが不可欠",
    deviceBreakdown: "デバイス別内訳",
    trafficSources: "トラフィックソース",
    topGeographicSources: "主要地域ソース",
    largest: "最大",
    topPagesVisited: "閲覧上位ページ",
    combinedFollowers: "総フォロワー数",
    monthlyImpressions: "月間インプレッション",
    organicGrowth: "オーガニック成長",
    avgEngagement: "平均エンゲージメント",
    followers: "フォロワー",
    topContent: "トップコンテンツ",
    topVideo: "トップ動画",
    views: "再生回数",
    retention: "リテンション",
    totalReaders: "総読者数",
    bookVisits: "ブック訪問数",
    avgReadTime: "平均読書時間",
    countries: "国",
    keyInsight: "主な洞察",
    readersPerIssue: "号別読者数（7号、1月〜10月2025年）",
    readTimeTrend: "読書時間トレンド（エンゲージメント上昇）",
    deviceAccess: "デバイスアクセス",
    regionalReach: "地域別リーチ",
    contentThemes: "コンテンツテーマ",
    devices: {
      desktopLaptop: "デスクトップ/ノートPC",
      mobilePhone: "スマートフォン",
      tablet: "タブレット"
    },
    trafficSourceTypes: {
      organicSearch: "オーガニック検索",
      direct: "ダイレクト",
      referral: "リファラル",
      paid: "有料",
      goodSeoVisibility: "良好なSEO可視性",
      strongBrandRecognition: "強力なブランド認知",
      socialPartnerships: "ソーシャル+パートナーシップ",
      limitedCampaigns: "限定キャンペーン"
    },
    topPagesData: {
      aboutJci: "JCIについて",
      newsEvents: "ニュースとイベント",
      whatWeDo: "私たちの活動",
      programsPage: "プログラム",
      getInvolved: "参加する",
      discoveringOrg: "組織を発見中の人々",
      engagementSeeking: "エンゲージメントを求めて",
      programInterest: "プログラムへの関心",
      actionOriented: "行動志向の訪問者",
      ctaMomentum: "CTAモメンタム"
    }
  },
  socialMediaData: {
    communityHub: "コミュニティハブ",
    visualStorytelling: "ビジュアルストーリーテリング",
    thoughtLeadership: "ソートリーダーシップ",
    longFormContent: "長編コンテンツ",
    fastestGrowth: "最速成長",
    consistentGrowth: "安定した成長",
    eventHighlights: "イベントハイライト",
    memberStories: "メンバーストーリー",
    campaigns: "キャンペーン",
    reels: "リール（3倍エンゲージメント）",
    visualStories: "ビジュアルストーリー",
    leadershipInsights: "リーダーシップインサイト",
    partnerships: "パートナーシップ",
    trainingSessions: "トレーニングセッション",
    reach: "リーチ",
    engagement: "エンゲージメント",
    impressions: "インプレッション",
    interactions: "インタラクション",
    watchTime: "視聴時間",
    whatIsJci: "JCIとは？"
  },
  futureSkills: {
    communicationPublicSpeaking: "コミュニケーションとパブリックスピーキング",
    communicationDesc: "リーダーシップと影響力に不可欠",
    criticalThinking: "クリティカルシンキングと問題解決",
    criticalThinkingDesc: "複雑な課題に対する分析スキル",
    conflictResolution: "紛争解決と交渉",
    conflictResolutionDesc: "紛争を管理し合意を構築する",
    projectManagement: "プロジェクト管理",
    projectManagementDesc: "効果的にイニシアチブを計画・実行",
    digitalTechLiteracy: "デジタル＆テクノロジーリテラシー",
    digitalTechDesc: "現代のテクノロジーツールを理解する",
    financialLiteracy: "ファイナンシャルリテラシー",
    financialLiteracyDesc: "予算管理と財務計画",
    interculturalCommunication: "異文化コミュニケーション",
    interculturalDesc: "文化を越えて効果的に働く",
    advocacyInfluence: "アドボカシーと影響力",
    advocacyDesc: "説得を通じて変化を促進"
  },
  technology: {
    title: "テクノロジーと未来",
    subtitle: "テクノロジー採用と将来のイノベーショントレンド",
    memberProfile: "メンバーテクノロジープロファイル",
    engagementMembers: "メンバーエンゲージメント",
    aiInLeadership: "リーダーシップにおけるAI",
    transformative: "変革的",
    aiDescription: "意思決定、パーソナライズドラーニング、自動化のためのAIツールが、若いリーダーの発展とリーダーシップの方法を再形成しています。",
    digitalFirstSkills: "デジタルファーストスキル",
    critical: "重要",
    digitalDescription: "データリテラシー、デジタルマーケティング、プログラミング、サイバーセキュリティは今やキャリアアップに不可欠なスキルです。",
    sustainabilityGreenTech: "サステナビリティとグリーンテック",
    essential: "必須",
    sustainabilityDescription: "気候テック、再生可能エネルギー、循環経済ソリューションが環境サステナビリティを推進しています。",
    mentalHealthTech: "メンタルヘルステック",
    growing: "成長中",
    mentalHealthDescription: "メンタルウェルネスアプリ、遠隔療法プラットフォーム、AIチャットボットがアクセスしやすいメンタルヘルスサポートを提供しています。",
    keyFocusAreas: "主要フォーカスエリア",
    source: "ソース",
    trendsResearchSources: "トレンド調査ソース",
    futureSkillsPriorities: "将来のスキル優先順位2025",
    futureSkillsSubtitle: "JCIメンバーによって特定されたリーダーシップ開発とキャリア成功のための必須コンピテンシー",
    priority: "優先度",
    skillsDevelopmentFramework: "スキル開発フレームワーク",
    skillsFrameworkDesc: "これらの優先順位はJCIのトレーニングプログラム、ワークショップ、リーダーシップ開発イニシアチブを導きます。メンバーは、コミュニケーション、クリティカルシンキング、デジタルリテラシーに特に重点を置き、2025年以降の進化する課題を乗り越えるために最も重要なコンピテンシーとしてこれらを特定しました。",
    veryHigh: "非常に高い",
    high: "高い",
    medium: "中程度",
    mediumHigh: "中〜高",
    emerging: "新興",
    // Focus area items
    aiAugmentedDecisionMaking: "AI強化された意思決定",
    personalizedLearningPaths: "パーソナライズされた学習パス",
    automatedAnalytics: "自動化されたアナリティクス",
    ethicalAIGovernance: "倫理的AIガバナンス",
    dataLiteracy: "データリテラシー",
    digitalMarketing: "デジタルマーケティング",
    programmingBasics: "プログラミング基礎",
    cybersecurityAwareness: "サイバーセキュリティ意識",
    climateTechnology: "気候テクノロジー",
    renewableEnergy: "再生可能エネルギー",
    circularEconomy: "循環経済",
    esgMeasurement: "ESG測定",
    wellnessApplications: "ウェルネスアプリケーション",
    teletherapyPlatforms: "遠隔療法プラットフォーム",
    aiSupportChatbots: "AIサポートチャットボット",
    stressManagementTools: "ストレス管理ツール"
  }
} as const;

